import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { toRoman } from 'roman-numerals';

interface PropTypes {
  chamber: number;
  column: number;
  letter: string;
  level: number;
}

export default function DisplayLocation({ chamber, column, letter, level }: PropTypes): JSX.Element {
  return (
    <Container>
      {/* {`${chamber ? toRoman(chamber) : 'X'}-${column ?? 'X'}-${letter ?? 'X'}-${level ?? 'X'}`} */}
      <Text>{chamber ? toRoman(chamber) : 'X'}</Text>
      <Text>{column ?? 'X'}</Text>
      <Text>{letter ?? 'X'}</Text>
      <TextBox style={{}}>{level ?? 'X'}</TextBox>
    </Container>
  );
}

const Container = styled.div`
  margin: 0 3px;
  padding: 3px 6px;
  background: #e7dfff;
  border-radius: 3px;
  width: fit-content;
`;

const Text = styled.span`
  font-size: 18px;
  font-weight: 500;
  margin: 0 2px;
`;

const TextBox = styled.span`
  font-size: 18px;
  font-weight: 500;
  margin: 0 2px;
  padding: 2px 5px;
  background: #fff;
  border-radius: 2px;
`;
